import { model as config, remote } from '~/shared/config'

export const $enabled = config.get(remote.tria_isSendCommonMediaClientData)
